import { useRef } from 'react';
import { useDateSegment } from 'react-aria';
import type { DateFieldState, DateSegment as TDateSegment } from 'react-stately';

interface DateSegmentProps {
  segment: TDateSegment;
  state: DateFieldState;
  className?: string;
  placeholderClassName?: string;
  literalClassName?: string;
}

export const DateSegment = ({
  segment,
  state,
  className,
  placeholderClassName,
  literalClassName,
}: DateSegmentProps) => {
  const ref = useRef(null);
  const { segmentProps } = useDateSegment(segment, state, ref);
  const segmentClassName = [
    className,
    segment.type === 'literal' ? literalClassName : '',
    segment.isPlaceholder ? placeholderClassName : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div {...segmentProps} ref={ref} className={segmentClassName || undefined}>
      {segment.text}
    </div>
  );
};
